import React, { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { GlobalContext } from "../context/GlobalState";

const status_ = {
  MARITIMA: (
    <img
      alt=""
      src="https://fsposeidon.blob.core.windows.net/roldan/icon_barco.png"
      width="50"
    ></img>
  ),
  AEREA: (
    <img
      alt=""
      src="https://fsposeidon.blob.core.windows.net/roldan/icon_avion.png"
      width="50"
    ></img>
  ),
  OTM: (
    <img
      alt=""
      src="https://fsposeidon.blob.core.windows.net/roldan/icon_camion.png"
      width="50"
    ></img>
  ),
  TERRESTRE: (
    <img
      alt=""
      src="https://fsposeidon.blob.core.windows.net/roldan/icon_camion.png"
      width="50"
    ></img>
  ),
};

export const InternacionalResults = (props) => {
  let { element } = props;
  const { ResultsList } = useContext(GlobalContext);

  function selectEmbarque() {
    console.log("DEL ELEMENTO ACTUAL ===> ", element);
    element.selectUser = true;
    ResultsList([element]);
  }

  return (
    <Fragment>
      <br />
      <div
        style={{
          background: "yellow",
          // marginLeft: "70px",
          // marginRight: "70px",
        }}
      >
        <Card className="_clickCard myCard" id={Math.random()}>
          <CardBody>
            <div className="row">
              <div className="container-fluid">
                <div className="row">
                  {/* ==========================ICONO===================================== */}
                  <div className="col-md-1">
                    <div className="row">
                      <div className="col">
                        <div className="mb-mail-meta">
                          <div className="mb-mail-from"></div>
                          <div className="mb-mail-subject">
                            {status_[element.ModoTransporte]}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* ========================== Status =========================================== */}
                  <div className="col-md-2">
                    <div className="mb-mail-meta">
                      <div className="mb-mail-subject">
                        <center>
                          <span
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          ></span>
                        </center>
                      </div>
                      <div className="mb-mail-from">
                        <center>
                          <span style={{ fontSize: "12px" }}>
                            {element.Estatus}
                          </span>
                        </center>
                      </div>
                    </div>
                  </div>
                  {/* ========================== DO EMBARQUE===================================== */}
                  <div className="col-md-2">
                    <div className="mb-mail-meta">
                      <div className="mb-mail-subject">
                        <center>
                          <span
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          ></span>
                        </center>
                      </div>
                      <div className="mb-mail-from">
                        <center>
                          <span style={{ fontSize: "12px" }}>
                            <Link
                              onClick={() => {
                                selectEmbarque();
                              }}
                              to={`/tracking/${element.ShipmentNumber}`}
                            >
                              {element.ShipmentNumber}
                            </Link>
                          </span>
                        </center>
                      </div>
                    </div>
                  </div>

                  {/* ========================== Instruccion===================================== */}
                  <div className="col-md-2">
                    <div className="mb-mail-meta">
                      <div className="mb-mail-subject">
                        <center>
                          <span
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            Origen
                          </span>
                        </center>
                      </div>
                      <div className="mb-mail-from">
                        <center>
                          <span style={{ fontSize: "12px" }}>
                            {element.POL}
                          </span>
                        </center>
                      </div>
                    </div>
                  </div>
                  {/* ========================== Destino ===================================== */}
                  <div className="col-md-2">
                    <div className="mb-mail-meta">
                      <div className="mb-mail-subject">
                        <center>
                          <span
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            Destino
                          </span>
                        </center>
                      </div>
                      <div className="mb-mail-from">
                        <center>
                          <span style={{ fontSize: "12px" }}>
                            {element.POD}
                          </span>
                        </center>
                      </div>
                    </div>
                  </div>
                  {/* ========================== Ref Client ===================================== */}
                  <div className="col-md-2">
                    <div className="mb-mail-meta">
                      <div className="mb-mail-subject">
                        <center>
                          <span
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            Referencia de Cliente
                          </span>
                        </center>
                      </div>
                      <div className="mb-mail-from">
                        <center>
                          <span style={{ fontSize: "12px" }}>
                            {element.RefCliente}
                          </span>
                        </center>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </Fragment>
  );
};
